<template lang="pug">
div.wrap-item-capture-frame
  div.wrap-back.f.fh
    v-icon(@click="onBack" :color="pallete.$active_color" size="30px") mdi-arrow-left-circle
  div(v-if="!resultBase64" @click="captureCanvas" :style="captureBtnStyle").capture-btn.f.fh.cursor-pointer
    v-icon(dark).mr2 mdi-camera
  div(v-else :style="captureBtnStyle").wrap-ok-btn.f.fm.flex-between
    //- span.btn-retake.btn.fz14.px10.py8 取り直す
    div(@click="resultBase64 = null").btn-retake.f.fh.mr8.cursor-pointer
      v-icon(size="20px") mdi-close
    div(@click="onOK").btn-ok.btn.fz14.px50.py8.cursor-pointer
      span(v-if="!isSaving") 保存
      v-progress-circular(v-else size="18" width="3" color="white" indeterminate)
  div(:class="{'photo-is-taken': resultBase64}"
    :style="captreAreaStyle").capture-area
    div(v-if="resultBase64").wrap-result-img
      img(:src="resultBase64")
      div(@click="onOK({ toEditByDrawing: true })").btn-to-edit.f.fm.cursor-pointer.px6.py6
        v-icon(size="20px" :color="pallete.$active_color" dark).mr4 mdi-draw
        span.fz16.bold 編集
    div(v-else).wrap-grid
      div.grid.grid-1
      div.grid.grid-2
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
$capture_btn_width: 120px;
$capture_btn_height: 32px;
$frame_area_border: solid 2px rgba(155, 155, 155, 0.6);
.wrap-item-capture-frame {
  .wrap-back {
    position: fixed;
    left: 16px; top: 10px;
    border-radius: 50%;
    overflow: hidden;
    background: $primary_bg_color;
    box-shadow: $box_shadow;
  }
  .capture-btn {
    position: fixed;
    width: $capture_btn_width; height: $capture_btn_height;
    left: calc(50% - #{$capture_btn_width} / 2);
    background: $active_color;
    border-radius: 12px;
    box-shadow: $box_shadow;
  }
  .wrap-ok-btn {
    position: fixed;
    width: 180px; height: $capture_btn_height;
    left: calc(50% - 160px / 2);
    .btn {
      color: $dark_primary_text_color;
      border-radius: 12px;
      box-shadow: $box_shadow;
    }
    .btn-retake {
      width: 32px; height: 32px;
      border-radius: 50%;
      background: $secondary_bg_color;
      box-shadow: $box_shadow;
    }
    .btn-ok {
      background: $active_color;
    }
  }
  .capture-area {
    position: fixed;
    pointer-events: none;
    border: $frame_area_border;
    .wrap-result-img {
      position: relative;
      .btn-to-edit {
        position: absolute;
        top: 12px; right: 12px;
        pointer-events: all;
        border-radius: 12px;
        border: solid 1px $active_color;
        color: $active_color;
        background: $overlay_white_color;
        // background: $overlay_color;
        // background: $active_color;
        // color: $dark_primary_text_color;
      }
    }
    .wrap-grid {
      position: relative;
      width: 100%; height: 100%;
      .grid {
        position: absolute;
      }
      .grid-1 {
        width: 100%; height: 33.3%;
        top: 33.3%; left: 0;
        border-top: $frame_area_border;
        border-bottom: $frame_area_border;
      }
      .grid-2 {
        width: 33.3%; height: 100%;
        top: 0%; left: 33.3%;
        border-left: $frame_area_border;
        border-right: $frame_area_border;
      }
    }
    &.photo-is-taken {
      outline: solid $active_color;
      // border: solid 2px $active_color;
      box-shadow: $box_shadow;
    }
  }
}
</style>

<script>
import database from '@/database'
import { storage } from '@/components/utils/firebase'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')

export default {
  props: {
    frame: {
      type: Object,
      required: true
    },
    assets: {
      type: Array,
      required: true
    },
    objects: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapStateAuth(['uid']),
    captreAreaStyle () {
      return `
        width: ${this.captureArea.w}px; height: ${this.captureArea.h}px;
        left: ${this.captureArea.x}px; top: ${this.captureArea.y}px;
      `
    },
    captureBtnStyle () {
      const topMargin = (window.innerHeight - this.captureArea.h) / 2
      const maginBetweenBtnAndFrame = 16
      return `top: ${topMargin - this.btnHeight - maginBetweenBtnAndFrame}px;`
    },
    adoptedAssetsInFrame () {
      let adoptedAssetsInFrame = {}
      this.objects.map(o => {
        const asset = this.assets.filter(a => a.id === o.assetId)[0]
        if (adoptedAssetsInFrame[asset.type]) {
          if (!adoptedAssetsInFrame[asset.type].includes(asset.id)) {
            adoptedAssetsInFrame[asset.type].push(asset.id)
          }
        } else {
          adoptedAssetsInFrame[asset.type] = [asset.id]
        }
      })
      return adoptedAssetsInFrame
    }
  },
  data () {
    return {
      captureArea: {},
      btnHeight: 32,
      resultBase64: null,
      isSaving: false
    }
  },
  created () {
    this.setCaptureArea()
  },
  mounted () {
    window.addEventListener('resize', this.setCaptureArea)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setCaptureArea)
  },
  methods: {
    async captureCanvas () {
      const canvas = this.$parent.$refs.wrapCanvas.firstElementChild
      const base64 = canvas.toDataURL('image/png')
      // console.log('base img base64:', base64)
      const resultCanvas = document.createElement('canvas')
      const resultCtx = resultCanvas.getContext('2d')
      // resultCanvas.width = this.captureArea.w
      // resultCanvas.height = this.captureArea.h

      const img = await this.loadImage(base64, 'Anonymous').catch(e => {
        console.log('onload error', e)
      })
      // NOTE base64(img)のwidth/heightがwindowWidthよりも一回り大きいことがある
      // のでsizeOffsetを設けて調整する
      const sizeOffset = canvas.width / canvas.clientWidth
      resultCanvas.width = this.captureArea.w * sizeOffset
      resultCanvas.height = this.captureArea.h * sizeOffset

      resultCtx.drawImage(img,
        -this.captureArea.x * sizeOffset, -this.captureArea.y * sizeOffset)

      // 解像度対策の試作中
      // resultCanvas.setAttribute('width', canvas.clientWidth)
      // resultCanvas.setAttribute('height', canvas.clientHeight)
      // // resultCanvas.width = canvas.clientWidth
      // // resultCanvas.height = canvas.clientHeight

      // resultCtx.drawImage(img,
      //   0, 0, img.width, img.height,
      //   -this.captureArea.x, -this.captureArea.y,
      //   img.width, img.height)
      
      // resultCtx.drawImage(img, -this.captureArea.x, -this.captureArea.y)
      // resultCtx.drawImage(img,
      //   0, 0, img.width, img.height,
      //   100, 100,
      //   img.width, img.height)
      // resultCtx.drawImage(img,
      //   this.captureArea.x, this.captureArea.y, img.width, img.height,
      //   100, 100,
      //   img.width, img.height)

      this.resultBase64 = resultCanvas.toDataURL('image/png')
      // console.log('this.resultBase64', this.resultBase64)
    },
    async onOK ({ toEditByDrawing=false }) {
      if (this.isSaving) return
      this.isSaving = true

      const base64Resized = await this.resizeImage(this.resultBase64)
      const imgURL = await this.uploadImg(base64Resized)

      let updateParams = { frameImg: imgURL, updatedAt: new Date() }
      if (this.frame.frameImg) {
        const frameImgHistories = this.frame.frameImgHistories ? 
          this.frame.frameImgHistories : []
        frameImgHistories.unshift({
          img: this.frame.frameImg,
          archievedAt: new Date()
        })
        updateParams.frameImgHistories = frameImgHistories
      }
      updateParams.adoptedAssetsInFrame = this.adoptedAssetsInFrame
      
      const rp = this.$route.params
      await database.frameCollection(rp.comicId, rp.episodeId, rp.pageId)
        .update(rp.frameId, updateParams)

      const path = (toEditByDrawing) ? 
        `/edit-comic/${rp.comicId}/${rp.episodeId}/${rp.pageId}/${rp.frameId}/drawing`
        : `/edit-comic/${rp.comicId}/${rp.episodeId}/${rp.pageId}`
      this.$router.push(path)

      // this.$router.push(`/edit-comic/${rp.comicId}/${rp.episodeId}/${rp.pageId}`)
      // this.$router.push(`/edit-comic/${rp.comicId}/${rp.episodeId}/${rp.pageId}/${rp.frameId}/drawing`)

      this.isSaving = false

      this.sendMixpanelEvent({ msg: 'captureNewFrameImage', info: { ...updateParams } })
    },
    async resizeImage (base64image) {
      const image = await this.loadImage(base64image, 'Anonymous')

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const THUMBNAIL_WIDTH = 1600
      const THUMBNAIL_HEIGHT = 1600

      let width, height, ratio
      if (image.width > image.height) {
        // 横長の画像は横のサイズを指定値にあわせる
        ratio = image.height / image.width
        width = THUMBNAIL_WIDTH
        height = THUMBNAIL_WIDTH * ratio
      } else {
        // 縦長の画像は縦のサイズを指定値にあわせる
        ratio = image.width / image.height
        width = THUMBNAIL_HEIGHT * ratio
        height = THUMBNAIL_HEIGHT
      }
      canvas.setAttribute('width', width)
      canvas.setAttribute('height', height)

      ctx.clearRect(0, 0, width, height)
      ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height)

      return canvas.toDataURL()
    },
    async uploadImg (base64) {
      const fileId = this.getUniqueStr()
      const storageRef = storage.ref()
      const ref = storageRef.child(`USER/${this.uid}/FRAME/${this.$route.params.frameId}/${fileId}`)
      const imgURL = await ref
        .putString(base64.split(',')[1], 'base64', {contentType: 'image/png'})
        .then(async (snapshot) => {
          return await snapshot.ref.getDownloadURL()
          .then(async downloadURL => downloadURL)
        })
      return imgURL
    },
    async setCaptureArea () {
      let w, h
      if (this.frame.size.w >= this.frame.size.h) {
        // captureArea.w = window.innerWidth
        // frame.w : frame.h = captureArea.w : captureArea.h
        // frame.w : frame.h = window.innerWidth : ?
        // ? = frame.h * (window.innerWidth / frame.w)

        // this.captureArea.w = window.innerWidth
        // this.captureArea.h = this.frame.size.h * (window.innerWidth / this.frame.size.w)
        // this.captureArea.x = 0
        // this.captureArea.y = (window.innerHeight - this.captureArea.h) / 2

        w = window.innerWidth
        h = this.frame.size.h * (window.innerWidth / this.frame.size.w)
        if (h >= window.innerHeight * 0.85) {
          h = window.innerHeight * 0.85
          // w : h = this.frame.size.w : this.frame.size.h
          // w * (this.frame.size.h / this.frame.size.w) = h
          w = h / (this.frame.size.h / this.frame.size.w)
        }
        this.captureArea = {
          w: w, h: h,
          x: (window.innerWidth - w) / 2,
          y: (window.innerHeight - h) / 2
        }
      } else {
        // captureArea.h = window.innerHeight * 0.95
        // frame.w : frame.h = captureArea.w : captureArea.h
        // frame.w : frame.h = ? : window.innerHeight * 0.95
        // ? = frame.w * (window.innerHeight / frame.h)

        // this.captureArea.h = window.innerHeight * 0.85
        // this.captureArea.w = this.frame.size.w * (window.innerHeight / this.frame.size.h)
        // this.captureArea.x = (window.innerWidth - this.captureArea.w) / 2
        // this.captureArea.y = (window.innerHeight - this.captureArea.h) / 2

        w = this.frame.size.w * (window.innerHeight / this.frame.size.h)
        h = window.innerHeight * 0.85
        if (w >= window.innerWidth) {
          w = window.innerWidth
          // w : h = this.frame.size.w : this.frame.size.h
          // w * (this.frame.size.h / this.frame.size.w) = h
          h = w * (this.frame.size.h / this.frame.size.w)
        }
        this.captureArea = {
          w: w, h: h,
          x: (window.innerWidth - w) / 2,
          y: (window.innerHeight - h) / 2
        }
      }
    },
    onBack () {
      this.resultBase64 = null
      this.$emit('stopCapturing')
    }
  }
}
</script>
